import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import { debuglog } from 'util';

class InfoPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DistributorInfo: [],
            header: 'My Info',
            loader: true,
            userdata: JSON.parse(localStorage.getItem('user')),
            ApiData: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        //this.GetRepsDetail();
        this.GetRepsDetailWithOutCND();
        var rowsShown = 6;
        var maxnoshow = 4;

        // first tab
        var rowsTotal = $('#inactive_reps .flex-table').length;
        var numPages = rowsTotal / rowsShown;
        for (var i = 0; i < numPages; i++) {
            var pageNum = i + 1;
            $('.tab1 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
            $('.tab1 select').append('<option val="' + i + '">' + pageNum + '</option> ');
        }
        $('#inactive_reps > div.flex-table').hide();
        $('#inactive_reps > div.flex-table').slice(0, rowsShown).show();

        // second tab
        var rowsTotal2 = $('#inactive_reps2 .flex-table').length;
        var numPages2 = rowsTotal2 / rowsShown;
        for (var i = 0; i < numPages2; i++) {
            var pageNum = i + 1;
            $('.tab2 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
            $('.tab2 select').append('<option val="' + i + '">' + pageNum + '</option> ');
        }
        $('#inactive_reps2 .flex-table').hide();
        $('#inactive_reps2 .flex-table').slice(0, rowsShown).show();

        $('.tab1 .nav_in a:first').addClass('active');
        $('.tab2 .nav_in a:first').addClass('active');
        $('.tab1 .nav_in a').hide();
        $('.tab2 .nav_in a').hide();
        $('.tab1 .nav_in a').slice(0, maxnoshow).show();
        $('.tab2 .nav_in a').slice(0, maxnoshow).show();
        $('.tab1 .nav_in a').bind('click', function () {
            $('.tab1 .nav_in a').removeClass('active');
            $(this).addClass('active');
            var currPage = $(this).attr('rel');
            var startItem = currPage * rowsShown;
            var endItem = startItem + rowsShown;
            $('#inactive_reps .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
            if ($(this).attr('rel') != '0') {
                $('.tab1 .nav_in a').hide();
                $(this).prev().show();
                $(this).show()
                $(this).next().show();
                $(this).next().next().show();
            }
        });
        $('.tab2 .nav_in a').bind('click', function () {
            $('.tab2 .nav_in a').removeClass('active');
            $(this).addClass('active');
            var currPage = $(this).attr('rel');
            var startItem = currPage * rowsShown;
            var endItem = startItem + rowsShown;
            $('#inactive_reps2 .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
            if ($(this).attr('rel') != '0') {
                $('.tab2 .nav_in a').hide();
                $(this).prev().show();
                $(this).show()
                $(this).next().show();
                $(this).next().next().show();
            }
        });
        $('.tab1 .prev-pagination').click(function () {
            if ($('.tab1 .nav_in .active').attr('rel') != '0') {
                $('.tab1 .nav_in .active').prev().addClass('active');
                $('.tab1 .nav_in .active').next().removeClass('active');
                $('.tab1 .nav_in a').hide();
                $('.tab1 .nav_in .active').prev().show();
                $('.tab1 .nav_in .active').show()
                $('.tab1 .nav_in .active').next().show();
                $('.tab1 .nav_in .active').next().next().next().show();
                let currentPage = $('.tab1 .nav_in .active').attr('rel');
                $('.tab1 .nav_in a').eq(currentPage).click();
            }
            if ($('.tab1 .nav_in .active').attr('rel') == '0') {
                $('.tab1 .nav_in a').hide();
                $('.tab1 .nav_in .active').show()
                $('.tab1 .nav_in .active').next().show();
                $('.tab1 .nav_in .active').next().next().show();
                $('.tab1 .nav_in .active').next().next().next().show();
            }
        });
        $('.tab2 .prev-pagination').click(function () {
            if ($('.tab2 .nav_in .active').attr('rel') != '0') {
                $('.tab2 .nav_in .active').prev().addClass('active');
                $('.tab2 .nav_in .active').next().removeClass('active');
                $('.tab2 .nav_in a').hide();
                $('.tab2 .nav_in .active').prev().show();
                $('.tab2 .nav_in .active').show()
                $('.tab2 .nav_in .active').next().show();
                $('.tab2 .nav_in .active').next().next().next().show();
                let currentPage = $('.tab2 .nav_in .active').attr('rel');
                $('.tab2 .nav_in a').eq(currentPage).click();
            }
            if ($('.tab2 .nav_in .active').attr('rel') == '0') {
                $('.tab2 .nav_in a').hide();
                $('.tab2 .nav_in .active').show()
                $('.tab2 .nav_in .active').next().show();
                $('.tab2 .nav_in .active').next().next().show();
                $('.tab2 .nav_in .active').next().next().next().show();
            }
        });
        $('.tab1 .next-pagination').click(function () {
            $('.tab1 .nav_in .active').next().addClass('active');
            $('.tab1 .nav_in .active').prev().removeClass('active');
            $('.tab1 .nav_in a').hide();
            $('.tab1 .nav_in .active').prev().show();
            $('.tab1 .nav_in .active').show()
            $('.tab1 .nav_in .active').next().show();
            $('.tab1 .nav_in .active').next().next().show();
            let currentPage = $('.tab1 .nav_in .active').attr('rel');
            $('.tab1 .nav_in a').eq(currentPage).click();
        });
        $('.tab2 .next-pagination').click(function () {
            $('.tab2 .nav_in .active').next().addClass('active');
            $('.tab2 .nav_in .active').prev().removeClass('active');
            $('.tab2 .nav_in a').hide();
            $('.tab2 .nav_in .active').prev().show();
            $('.tab2 .nav_in .active').show()
            $('.tab2 .nav_in .active').next().show();
            $('.tab2 .nav_in .active').next().next().show();
            let currentPage = $('.tab2 .nav_in .active').attr('rel');
            $('.tab2 .nav_in a').eq(currentPage).click();
        });
        $('.tab1 .first_row').click(function () {
            $('.tab1 .nav_in a').eq(0).click();
            $('.tab1  .nav_in a').hide().removeClass('active');
            $('.tab1 .nav_in a:first-child').addClass('active').show();
            $('.tab1 .nav_in .active').next().show();
            $('.tab1 .nav_in .active').next().next().show();
            $('.tab1 .nav_in .active').next().next().next().show();
        });
        $('.tab1 .last_row').click(function () {
            $('.tab1 .nav_in a:last-child').click();
            $('.tab1 .nav_in a').hide().removeClass('active');
            $('.tab1 .nav_in a:last-child').addClass('active').show();
            $('.tab1 .nav_in .active').prev().show();
            $('.tab1 .nav_in .active').prev().prev().show();
            $('.tab1 .nav_in .active').prev().prev().prev().show();
        });
        $('.tab2 .first_row').click(function () {
            $('.tab2 .nav_in a').eq(0).click();
            $('.tab2 .nav_in a').hide().removeClass('active');
            $('.tab2 .nav_in a:first-child').addClass('active').show();
            $('.tab2 .nav_in .active').next().show();
            $('.tab2 .nav_in .active').next().next().show();
            $('.tab2 .nav_in .active').next().next().next().show();
        });
        $('.tab2 .last_row').click(function () {
            $('.tab2 .nav_in a:last-child').click();
            $('.tab2 .nav_in a').hide().removeClass('active');
            $('.tab2 .nav_in a:last-child').addClass('active').show();
            $('.tab2 .nav_in .active').prev().show();
            $('.tab2 .nav_in .active').prev().prev().show();
            $('.tab2 .nav_in .active').prev().prev().prev().show();
        });
        $('.tab1 select').change(function () {
            var getpage = $(this).val() - 1;
            $('.tab1 .nav_in a').eq(getpage).click();
        });
        $('.tab2 select').change(function () {
            var getpage = $(this).val() - 1;
            $('.tab2 .nav_in a').eq(getpage).click();
        });
    }
    GetRepsDetail() {
        try {
            let baseurl = "https://cnd.23byt.es/";
            if (this.state.userdata.wholesaler == "Avenel") {
                baseurl = baseurl + 'avds/disinfo?Distributor=' + this.state.userdata.email;
            }
            else {
                baseurl = baseurl + 'ds/disinfo?Distributor=' + this.state.userdata.paramsname;
            }
            fetch(baseurl)
                .then(response => response.json())
                .then(data => {
                    this.setState({ DistributorInfo: data, loader: false, ApiData: true });
                });
        }
        catch (error) {
        }
    }
    GetRepsDetailWithOutCND() {
        try {
            let RoleName = "";
            if (this.state.userdata.wholesaler == "Avenel") {
                RoleName = this.state.userdata.paramsname;
            }
            else {
                RoleName = this.state.userdata.paramsname;
            }
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({
                    'RoleName': RoleName, 'RoleType': this.state.userdata.wholesaler, 'wholesaler_Id': this.state.userdata.wholesaler_Id, 'distributor_UserId': this.state.userdata.distributor_UserId
                })
            };
            return fetch(`/api/ds/repsNewInfo`, requestOptions)
                //fetch(baseurl)           `
                .then(response => response.json())
                .then(data => {
                    this.setState({ DistributorInfo: data, loader: false, ApiData: true });
                });
        }
        catch (error) {
        }
    }
    render() {
        const { DistributorInfo } = this.state;
        return (
            <div className='popup mfp-zoom-in'>
                <div className='popup_inner myinfo'>
                    {
                        this.state.loader ? (<div className="theme-loader info"></div>) : null
                    }
                    <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>

                    <div>
                        {
                            DistributorInfo != null && DistributorInfo.length > 0 ?
                                <div className="flex-container" key={"Active"} >
                                    <span>Total Active Reps</span>
                                    <p>{DistributorInfo[0].activeCount} Reps</p>
                                    <span>Total InActive Reps</span>
                                    <p>{DistributorInfo[0].inactiveCount} Reps</p>
                                    <span>Assigned Group Numbers(My Commission Per Claim)</span>
                                    <div className="claim">
                                        <ul>
                                            {
                                                DistributorInfo != null && DistributorInfo.length > 0 ?
                                                    DistributorInfo.map((gpitem, _index) => {
                                                        return <li>{gpitem.groupNumber}</li>
                                                    }) : null
                                            }

                                        </ul>
                                    </div>
                                    <a href="javascript:;" className="closeBtn btn-theme-color" onClick={this.props.closePopup}>Close</a>
                                </div> : <div className="data-not-available">{this.state.ApiData == true ? 'Data not available' : ''}</div>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

export default InfoPopup;